import {createRef, useEffect, useRef, useState, type ReactNode} from 'react';

import {isNotNil} from 'ramda';

import {debounce} from 'shared/web';

import {NavigationContext, type Section} from './NavigationContext';

export const NavigationContextProvider = ({children}: {children: ReactNode}) => {
  const sections = useRef<Section[]>([]);
  const [activeSection, setActiveSection] = useState(0);

  useEffect(function trackActiveSectionOnScroll() {
    const handleScroll = debounce(() => {
      const scrollPosition = window.scrollY;
      const activeSection = sections.current
        .map((section) => section.ref)
        .findIndex((ref) =>
          isNotNil(ref?.current)
            ? ref.current.offsetTop + ref.current.clientHeight > scrollPosition
            : false
        );
      setActiveSection(activeSection);
    }, 50);

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const registerSection = (title: string) => {
    const section = sections.current.find((section) => section.title === title);

    if (isNotNil(section)) {
      return section.ref;
    } else {
      const ref = createRef<HTMLDivElement>();
      sections.current.push({title, ref});
      return ref;
    }
  };

  return (
    <NavigationContext.Provider
      value={{sections: sections.current, registerSection, activeSection}}
    >
      {children}
    </NavigationContext.Provider>
  );
};
